const translations = {
  "subscription.flow.tier.title.new": "Complete your membership",
  "subscription.flow.tier.title.upgrade": "Upgrade plan",
  "subscription.flow.tier.upsell.title": "Switch to the annual plan, save ${value}, and level up your game!",
  "subscription.flow.tier.upsell.description": "Upgrade now to our ${price} per year {name} plan and experience the convenience and value of our annual plans.",
  "subscription.flow.tier.upsell.btn.switch": "Switch to annual",
  "subscription.flow.tier.upsell.btn.stay": "Stay on monthly",
  "subscription.flow.tier.downgrade": "Change of plan completed",
  "subscription.flow.tier.cancel.success": "Change of plan cancelled successfully",

  "subscription.flow.billing.checkout.title": "Checkout",
  "subscription.flow.billing.checkout.totals.subtotal": "Plan fee",
  "subscription.flow.billing.checkout.totals.credit": "Prorated amount",
  "subscription.flow.billing.checkout.totals.credit.tooltip": "We've deducted what you've paid in your current plan to date",
  "subscription.flow.billing.checkout.totals.total": "Total Due Today",
  "subscription.flow.billing.checkout.payment.title": "Payment Details",

  "subscription.flow.billing.checkout.upgrade.success": "Membership upgraded successfully",
  "subscription.flow.billing.checkout.card.success": "Card added successfully",
  "subscription.flow.billing.checkout.recharge.success": "Membership activated successfully",

  // Review mode
  "subscription.flow.billing.checkout.review.title": "Activate Subscription",
  "subscription.flow.billing.checkout.review.msg.expired": "Your {name} subscription is currently inactive because your card is expired. Please update your payment details to reactivate it.",
  "subscription.flow.billing.checkout.review.msg.generic": "Your {name} subscription is currently inactive because there was a failed attempt to charge your recurring membership fee. Please update your payment details to reactivate it.",
  "subscription.flow.billing.checkout.review.btn.change": "Change Payment Method",
  "subscription.flow.billing.checkout.review.btn.charge": "Charge Again",
};

export default translations;